import React, {
    useEffect,
    useRef
}
from "react";

import * as am4core
from "@amcharts/amcharts4/core";

import * as am4plugins_sunburst
from "@amcharts/amcharts4/plugins/sunburst";

import am4themes_animated
from "@amcharts/amcharts4/themes/animated";

import { LICENCE_KEY }
from "../../../../constants/charts";


am4core.useTheme(
    am4themes_animated
);

am4core.addLicense(
    LICENCE_KEY
);


export default function InsightDashboardHeroChart({
    data = [],
    clickFunction
})
{

    const chartRef =
        useRef(null);


    //--------------------------------------------------------
    // Map dashboard data
    //--------------------------------------------------------

	//--------------------------------------------------------
	// Map dashboard data
	//--------------------------------------------------------

	function mapData(rows)
	{
	    //----------------------------------------------------
	    // Grand total across entire portfolio
	    //----------------------------------------------------

	    const grandTotal =
	        rows.reduce(
	            (total, category) =>
	            {
	                return (
	                    total
	                    +
	                    (
	                        category.total
	                        ||
	                        0
	                    )
	                );
	            },
	            0
	        );


	    //----------------------------------------------------
	    // Build chart hierarchy
	    //----------------------------------------------------

	    return rows.map(
	        (category) =>
	        {
	            const subcategories =
	                category.subcategories
	                ||
	                [];


	            return {
	                name:
	                    category.category,

	                value:
	                    category.total,

	                type:
	                    "CATEGORY",

	                originalData:
	                    category,

	                children:
	                    subcategories.map(
	                        (subcategory) =>
	                        {
	                            const value =
	                                subcategory.total
	                                ||
	                                0;


	                            //------------------------------------------------
	                            // Percentage of ENTIRE portfolio
	                            //------------------------------------------------

	                            const percentage =
	                                grandTotal > 0
	                                    ?
	                                    (
	                                        value
	                                        /
	                                        grandTotal
	                                    )
	                                    *
	                                    100
	                                    :
	                                    0;


	                            return {
	                                name:
	                                    subcategory.name,

	                                value:
	                                    value,

	                                percentage:
	                                    percentage,

	                                /*
	                                 * Only show labels for slices
	                                 * large enough to matter visually.
	                                 *
	                                 * This is percentage of the
	                                 * ENTIRE sunburst, not its parent.
	                                 */

	                                labelOpacity:
	                                    percentage >= 0.5
	                                        ?
	                                        1
	                                        :
	                                        0,

	                                type:
	                                    "SUBCATEGORY",

	                                originalData:
	                                    subcategory
	                            };
	                        }
	                    )
	            };
	        }
	    );
	}

    //--------------------------------------------------------
    // Create chart
    //--------------------------------------------------------

    useEffect(
        () =>
        {
            if(
                !data
                ||
                data.length === 0
            )
            {
                return;
            }


            const chart =
                am4core.create(
                    "insight-dashboard-hero-chart",
                    am4plugins_sunburst.Sunburst
                );


            chart.padding(
                10,
                10,
                10,
                10
            );


            chart.radius =
                am4core.percent(96);

            chart.innerRadius =
                am4core.percent(24);


            //------------------------------------------------
            // Data fields
            //------------------------------------------------

            chart.dataFields.value =
                "value";

            chart.dataFields.name =
                "name";

            chart.dataFields.children =
                "children";


            chart.data =
                mapData(
                    data
                );


            //------------------------------------------------
            // Category ring
            //------------------------------------------------

            const categorySeries =
                new am4plugins_sunburst
                    .SunburstSeries();


            chart.seriesTemplates.setKey(
                "0",
                categorySeries
            );


            //------------------------------------------------
            // Category slices
            //------------------------------------------------

            categorySeries.slices.template.stroke =
                am4core.color(
                    "#ffffff"
                );

            categorySeries.slices.template.strokeWidth =
                2;

            categorySeries.slices.template.strokeOpacity =
                0.75;


            categorySeries.slices.template.tooltipText =
                "{name}\n[bold]{value} insights[/]";


            //------------------------------------------------
            // Category labels
            //------------------------------------------------

            categorySeries.labels.template.truncate =
                true;

            categorySeries.labels.template.hideOversized =
                true;

            categorySeries.labels.template.fontSize =
                9;

            categorySeries.labels.template.fontWeight =
                "400";

            categorySeries.labels.template.fill =
                am4core.color(
                    "#ffffff"
                );


            //------------------------------------------------
            // Hide very small category labels
            //------------------------------------------------

            categorySeries.labels.template
                .adapter
                .add(
                    "disabled",
                    function(disabled, target)
                    {
                        const dataItem =
                            target.dataItem;


                        if(
                            !dataItem
                            ||
                            !dataItem.slice
                        )
                        {
                            return disabled;
                        }


                        const arc =
                            Math.abs(
                                dataItem.slice.arc
                                ||
                                0
                            );


                        if(arc < 3)
                        {
                            return true;
                        }


                        return false;
                    }
                );


            //------------------------------------------------
            // Category hover
            //------------------------------------------------

            const categoryHover =
                categorySeries.slices.template
                    .states
                    .getKey(
                        "hover"
                    );


            categoryHover.properties.scale =
                1.025;

				//------------------------------------------------
				// Category click
				//------------------------------------------------

				categorySeries.slices.template
				    .events
				    .on(
				        "hit",
				        function(event)
				        {
				            if(!clickFunction)
				            {
				                return;
				            }


				            const item =
				                event.target
				                    .dataItem
				                    .dataContext;


				            console.log(
				                "CATEGORY RAW:",
				                item
				            );


				            if(!item)
				            {
				                return;
				            }


				            clickFunction(
				                item,
				                "CATEGORY"
				            );
				        }
				    );

            //------------------------------------------------
            // Subcategory ring
            //
            // IMPORTANT:
            //
            // This is deliberately a NEW series rather than
            // a clone of categorySeries.
            //
            // That prevents category label adapters/settings
            // being inherited by the outer ring.
            //------------------------------------------------

            const subcategorySeries =
                new am4plugins_sunburst
                    .SunburstSeries();


            chart.seriesTemplates.setKey(
                "1",
                subcategorySeries
            );


            subcategorySeries.hiddenInLegend =
                true;
				
				
			

            //------------------------------------------------
            // Subcategory slices
            //------------------------------------------------

            subcategorySeries.slices.template.stroke =
                am4core.color(
                    "#ffffff"
                );


            //------------------------------------------------
            // Adaptive subcategory borders
            //------------------------------------------------

            subcategorySeries.slices.template
                .adapter
                .add(
                    "strokeWidth",
                    function(strokeWidth, target)
                    {
                        const dataItem =
                            target.dataItem;


                        if(
                            !dataItem
                            ||
                            !dataItem.slice
                        )
                        {
                            return strokeWidth;
                        }


                        const arc =
                            Math.abs(
                                dataItem.slice.arc
                                ||
                                0
                            );


                        /*
                         * Microscopic slices:
                         * remove separator completely.
                         */

                        if(arc < 1.5)
                        {
                            return 0;
                        }


                        /*
                         * Small slices:
                         * very subtle separator.
                         */

                        if(arc < 4)
                        {
                            return 0.35;
                        }


                        /*
                         * Normal slices.
                         */

                        return 1;
                    }
                );


            subcategorySeries.slices.template
                .adapter
                .add(
                    "strokeOpacity",
                    function(strokeOpacity, target)
                    {
                        const dataItem =
                            target.dataItem;


                        if(
                            !dataItem
                            ||
                            !dataItem.slice
                        )
                        {
                            return strokeOpacity;
                        }


                        const arc =
                            Math.abs(
                                dataItem.slice.arc
                                ||
                                0
                            );


                        if(arc < 1.5)
                        {
                            return 0;
                        }


                        if(arc < 4)
                        {
                            return 0.25;
                        }


                        return 0.65;
                    }
                );


            //------------------------------------------------
            // Subcategory tooltip
            //------------------------------------------------

            subcategorySeries.slices.template.tooltipText =
                "{name}\n[bold]{value} insights[/]";


            //------------------------------------------------
            // Subcategory labels
            //
            // IMPORTANT:
            //
            // For now we are intentionally NOT applying
            // any hidden/disabled adapter.
            //
            // We want amCharts to prove it can render the
            // labels first.
            //------------------------------------------------

            subcategorySeries.labels.template.disabled =
                false;

            subcategorySeries.labels.template.hidden =
                false;

            subcategorySeries.labels.template.truncate =
                true;

            subcategorySeries.labels.template.hideOversized =
                false;


            subcategorySeries.labels.template.fontSize =
                7;

            subcategorySeries.labels.template.fontWeight =
                "400";

            subcategorySeries.labels.template.fill =
                am4core.color(
                    "#ffffff"
                );
				
				subcategorySeries.labels.template
				    .propertyFields.opacity =
				        "labelOpacity";	


            //------------------------------------------------
            // Subcategory hover
            //------------------------------------------------

            const subcategoryHover =
                subcategorySeries
                    .slices
                    .template
                    .states
                    .getKey(
                        "hover"
                    );


            subcategoryHover.properties.scale =
                1.015;


            //------------------------------------------------
            // Subcategory click
            //------------------------------------------------

            subcategorySeries.slices.template
                .events
                .on(
                    "hit",
                    function(event)
                    {
                        if(!clickFunction)
                        {
                            return;
                        }


                        const item =
                            event.target
                                .dataItem
                                .dataContext;


                        if(!item)
                        {
                            return;
                        }


                        clickFunction(
                            item.originalData,
                            "SUBCATEGORY"
                        );
                    }
                );


            //------------------------------------------------
            // Save reference
            //------------------------------------------------

            chartRef.current =
                chart;


            //------------------------------------------------
            // Cleanup
            //------------------------------------------------

            return () =>
            {
                chart.dispose();

                chartRef.current =
                    null;
            };
        },
        [
            data,
            clickFunction
        ]
    );


    //--------------------------------------------------------
    // Render
    //--------------------------------------------------------

    return (

        <div
            style={{
                position: "relative",
                width: "100%",
                height: "100%"
            }}
        >

            <div
                id="insight-dashboard-hero-chart"

                style={{
                    width: "100%",
                    height: "100%"
                }}
            />


            <div style={centreLabelStyle}>

                <div style={centreEyebrowStyle}>
                    PORTFOLIO
                </div>

                <div style={centreTitleStyle}>
                    Insights
                </div>

            </div>

        </div>

    );
}


//--------------------------------------------------------
// Centre label
//--------------------------------------------------------

const centreLabelStyle =
{
    position: "absolute",

    left: "50%",
    top: "50%",

    transform:
        "translate(-50%, -50%)",

    display: "flex",
    flexDirection: "column",
    alignItems: "center",

    pointerEvents: "none",
	backgroundColor:'white',
	padding:"20px",
	borderRadius:'200px',
	height:'60px',
	width:'80px',
	paddingTop:'40px'
};


const centreEyebrowStyle =
{
    color: "#9099a7",

    fontSize: "8px",
    fontWeight: "800",

    letterSpacing: "1.4px"
};


const centreTitleStyle =
{
    marginTop: "3px",

    color: "#252b34",

    fontSize: "15px",
    fontWeight: "800"
};